"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OasisError = exports.ErrorType = void 0;
var tslib_1 = require("tslib");
var ErrorType;
(function (ErrorType) {
    ErrorType["UNKNOWN"] = "unknown";
    ErrorType["AD"] = "ad";
    ErrorType["AD_BLOCKED"] = "ad_blocked";
    ErrorType["AD_NO_SUPPORTED_MEDIAFILE_PROVIDED"] = "ad_no_supported_mediafile_provided";
    ErrorType["AD_MEDIAFILE_ERROR"] = "ad_mediafile_error";
    ErrorType["AD_VIEWABILITY_ERROR"] = "ad_viewability_error";
    ErrorType["AD_NO_NETWORK_CONNECTION"] = "ad_no_network_connection";
    ErrorType["AD_SLOW_NETWORK_CONNECTION"] = "ad_slow_network_connection";
    // Examples:
    // AD_VIDEO = 'ad_video',
    // AD_VIDEO_PLAYBACK = 'ad_video_playback',
    // AD_VPAID = 'ad_vpaid',
    // AD_VAST_ERROR = 'ad_vast_error',
    // AD_VAST_ERROR_101 = 'ad_vast_error_101', // Maybe... could be dynamically mapped or already from bumblebee
    // AD_VAST_ERROR_102 = 'ad_vast_error_102', // Maybe... could also just only have AD_VAST_ERROR
    // ...
    ErrorType["CONTENT"] = "content";
    ErrorType["CONTENT_GEOBLOCKING"] = "content_geoblocking";
    ErrorType["CONTENT_DRMBLOCKING"] = "content_drmblocking";
    ErrorType["CONTENT_UNAVAILABLE"] = "content_unavailable";
    ErrorType["CONTENT_TAKEDOWN"] = "content_takedown";
    ErrorType["CONTENT_UNKNOWN"] = "content_unknown";
    ErrorType["CONTENT_YOUTH_PROTECTED"] = "content_youth_protected";
    ErrorType["CONTENT_MAX_ALLOWED_ACTIVE_STREAMS"] = "content_max_allowed_active_streams";
    // ...
    ErrorType["PLAYBACK"] = "playback";
    ErrorType["PLAYBACK_DRM"] = "playback_drm";
    ErrorType["PLAYBACK_PLAY_WITHOUT_SOURCES"] = "playback_play_without_sources";
    ErrorType["PLAYBACK_DRM_KEY_SYSTEM_NOT_SUPPORTED"] = "playback_drm_key_system_not_supported";
    ErrorType["PLAYBACK_DRM_OUTPUT_RESTRICTED"] = "playback_drm_output_restricted";
    ErrorType["PLAYBACK_NO_SOURCE_PROVIDED"] = "playback_no_source_provided";
    ErrorType["PLAYBACK_NO_SUPPORTED_SOURCE_PROVIDED"] = "playback_no_supported_source_provided";
    ErrorType["PLAYBACK_SOURCE_INVALID"] = "playback_source_invalid";
    ErrorType["PLAYBACK_NETWORK_CONNECTION_PROBLEM"] = "playback_network_connection_problem";
    ErrorType["PLAYBACK_DESTROYED"] = "playback_destroyed";
    // ...
    ErrorType["INTERNAL"] = "internal";
    ErrorType["PLAYER_CONFIG"] = "player_config";
    // ... + all the stuff we care about but maybe not all bitmovin errors
    ErrorType["PIN_IS_MISSING"] = "pin_is_missing";
    ErrorType["PIN_VALIDATION_FAILED"] = "pin_validation_failed";
    ErrorType["MAXIMUM_PARALLEL_STREAMS_REACHED"] = "maximum_parallel_streams_reached";
    ErrorType["MIRA_TOKEN_IS_MISSING"] = "mira_token_is_missing";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
var getErrorTypeValues = function () {
    return Object.keys(ErrorType).map(function (type) { return ErrorType[String(type)]; });
};
var OasisError = /** @class */ (function (_super) {
    tslib_1.__extends(OasisError, _super);
    function OasisError(message, type, payload) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.payload = payload;
        _this.type = ErrorType.UNKNOWN;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        _this.type = type || ErrorType.UNKNOWN;
        return _this;
    }
    OasisError.fromObject = function (error, fallbackType) {
        if (error instanceof OasisError)
            return error;
        var _a = error || {}, _b = _a.message, message = _b === void 0 ? null : _b, _c = _a.code, code = _c === void 0 ? null : _c;
        var _d = (error || {}).type, type = _d === void 0 ? null : _d;
        var messageParts = [];
        var errorTypeValues = getErrorTypeValues();
        if (message)
            messageParts.push(message);
        if (code)
            messageParts.push("(code: ".concat(code, ")"));
        if (!errorTypeValues.includes(type)) {
            if (type)
                messageParts.push("(type: ".concat(type, ")"));
            type = fallbackType || ErrorType.UNKNOWN;
        }
        var fullMessage = messageParts.length ? messageParts.join(' ') : undefined;
        return new OasisError(fullMessage, type);
    };
    OasisError.prototype.hasType = function (type) {
        return this.type && this.type.startsWith(type);
    };
    return OasisError;
}(Error));
exports.OasisError = OasisError;
//# sourceMappingURL=error.js.map